import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import { FulfilmentRingChart } from './FulfilmentRingChart'

interface Props {
  title: string
  value: string
  caption: string
  color: string
  info?: string
  ringPercentage?: number
  loading?: boolean
}

export const FulfilmentKpiCard = ({
  title,
  value,
  caption,
  color,
  info,
  ringPercentage,
  loading,
}: Props) => (
  <Paper
    variant='outlined'
    sx={{
      p: 2.5,
      height: '100%',
      borderRadius: 2,
      bgcolor: alpha(color, 0.05),
      borderColor: alpha(color, 0.25),
    }}>
    <Stack direction='row' spacing={2} justifyContent='space-between' alignItems='center'>
      <Box>
        <Stack direction='row' spacing={1} alignItems='center' mb={1}>
          <Typography variant='subtitle2' fontWeight={700} sx={{ color }}>
            {title}
          </Typography>
          {info && (
            <Tooltip title={info}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          )}
        </Stack>

        {loading ? (
          <Skeleton width={90} height={44} />
        ) : (
          <Typography variant='h4' fontWeight={700} sx={{ color }}>
            {value}
          </Typography>
        )}

        <Typography variant='caption' color='text.secondary'>
          {caption}
        </Typography>
      </Box>

      {ringPercentage != null &&
        (loading ? (
          <Skeleton variant='circular' width={88} height={88} />
        ) : (
          <FulfilmentRingChart percentage={ringPercentage} color={color} />
        ))}
    </Stack>
  </Paper>
)
